import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';

export const getFilterConfig = ({ t }: { t: TFunction }) => [
  {
    id: 'isSeen',
    size: 2,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('notifications.list.filter.is-seen'),
        name: 'isSeen',
        label: t('notifications.list.filter.is-seen'),
      },
      options: [
        {
          value: true,
          name: t('notifications.list.filter.read'),
        },
        {
          value: false,
          name: t('notifications.list.filter.unread'),
        },
      ],
    },
  },
];
